import React from "react"
import { AnimatePresence, motion } from "framer-motion"
import { Link } from "gatsby"
import {
  intro,
  linkedLists,
  stacks,
  queues,
  trees,
  graphs,
  searching,
  sorting,
  stringMatching,
  dynamicProgramming,
  greedyTechnique,
} from "./dsaInfo"

function DSA({ show }) {
  return (
    <AnimatePresence>
      {show && (
        <div className="container mx-auto my-3">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className="row bg-light mx-1 py-2"
            style={listStyle}
          >
            <div className="col-12 table-responsive">
              <table className="table table-striped">
                <thead className="bg-dark text-light">
                  <tr>
                    <th>Topic</th>
                    <th>Blogs</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Intro</td>
                    <td>
                      <ul className="pl-3">
                        {intro.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Linked List Data Structure</td>
                    <td>
                      <ul className="pl-3">
                        {linkedLists.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Stack Data Structure</td>
                    <td>
                      <ul className="pl-3">
                        {stacks.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Queue Data Structure</td>
                    <td>
                      <ul className="pl-3">
                        {queues.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Tree Data Structure</td>
                    <td>
                      <ul className="pl-3">
                        {trees.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Graph Data Structure</td>
                    <td>
                      <ul className="pl-3">
                        {graphs.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Searching Algorithms</td>
                    <td>
                      <ul className="pl-3">
                        {searching.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Sorting Algorithms</td>
                    <td>
                      <ul className="pl-3">
                        {sorting.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>String Matching Algorithms</td>
                    <td>
                      <ul className="pl-3">
                        {stringMatching.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Dynamic Programming</td>
                    <td>
                      <ul className="pl-3">
                        {dynamicProgramming.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>Greedy Technique</td>
                    <td>
                      <ul className="pl-3">
                        {greedyTechnique.map(({ link, title }) => (
                          <li key={link + title}>
                            <Link
                              to={`/blogs/${link}`}
                              className="text-decoration-none"
                            >
                              {title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  )
}

export default DSA

const listStyle = {
  width: "100%",
  minHeight: "100vh",
  borderRadius: "10px",
  background: "white",
}

const containerVariants = {
  hidden: {
    scale: 0,
  },
  visible: {
    scale: 1,
    transition: {
      delay: 0.2,
      duration: 0.5,
    },
  },
  exit: {
    scale: 0,
    transition: {
      delay: 0.2,
      duration: 0.5,
      ease: "easeInOut",
    },
  },
}
